import RevolverSettings from "model/revolver-settings";
import gameState from "slotworks/model/game-state";
import soundManager from "slotworks/sound/sound-manager";

export function StartBaseMusic(update: boolean = false) {
    if (!gameState.getCurrentGame().inFreespinsGame) {
        if (update) RevolverSettings.lastWinTime = Date.now();
        
        if (RevolverSettings.winCount == 0 || Date.now() - RevolverSettings.lastWinTime > 10000) {
            soundManager.customEvent("base_music");
            RevolverSettings.winCount = 0;
        } else {
            if (RevolverSettings.winCount == 1) {
                soundManager.customEvent("base_win_progressive_1");
            } else {
                soundManager.customEvent("base_win_progressive_2");
            }
        }
    }
}

export function StartBaseMusicMid() {
    if (!gameState.getCurrentGame().inFreespinsGame) {
        if (RevolverSettings.winCount == 0 || Date.now() - RevolverSettings.lastWinTime > 10000) {
            soundManager.customEvent("base_music_mid");
            RevolverSettings.winCount = 0;
        } else {
            if (RevolverSettings.winCount == 1) {
                soundManager.customEvent("base_win_progressive_1_mid");
            } else {
                soundManager.customEvent("base_win_progressive_2_mid");
            }
        }
    }
}

export function StartBaseMusicSoft() {
    if (!gameState.getCurrentGame().inFreespinsGame) {
        if (RevolverSettings.winCount == 0 || Date.now() - RevolverSettings.lastWinTime > 10000) {
            soundManager.customEvent("base_music_soft");
            RevolverSettings.winCount = 0;
        } else {
            if (RevolverSettings.winCount == 1) {
                soundManager.customEvent("base_win_progressive_1_soft");
            } else {
                soundManager.customEvent("base_win_progressive_2_soft");
            }
        }
    }
}